import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PlanetView from './components/planet/PlanetView';
import TeacherDashboard from './components/teacher/TeacherDashboard';
import LandingPage from './components/LandingPage';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import { useState } from 'react';
import { getAdminToken, clearAdminToken } from './api/admin';
import { getGameSession } from './api/client';

function App() {
  const session = getGameSession();
  const hasLegacyDevUser = !!localStorage.getItem('dev_user_id');
  const isStudent = session?.role === 'student' || (!session && hasLegacyDevUser);
  const isTeacher = session?.role === 'teacher' || session?.role === 'admin' || (!session && hasLegacyDevUser);
  const [adminLoggedIn, setAdminLoggedIn] = useState(!!getAdminToken());

  const handleAdminLogin = () => setAdminLoggedIn(true);
  const handleAdminLogout = () => {
    clearAdminToken();
    setAdminLoggedIn(false);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={session?.role === 'teacher' || session?.role === 'admin' ? <Navigate to="/teacher" replace /> : isStudent ? <PlanetView /> : <LandingPage />} />
        <Route path="/teacher" element={isTeacher ? <TeacherDashboard /> : <LandingPage />} />
        <Route
          path="/admin"
          element={
            adminLoggedIn ? (
              <AdminDashboard onLogout={handleAdminLogout} />
            ) : (
              <AdminLogin onLogin={handleAdminLogin} />
            )
          }
        />
        <Route path="*" element={isStudent ? <PlanetView /> : <LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
